<div #chatWrapper
     id="chat-wrapper"
     class="chat-wrapper">

  <div *ngIf="isLoadingPreviousMessages"
       class="loading-spinner-container">
    <i class="fas fa-spinner fa-spin"></i>
  </div>
  <div *ngIf="!messages"
       class="container">
    <nz-skeleton *ngFor="let index of [0, 1, 2, 3, 4, 6]"
                 [nzAvatar]="true"
                 [nzActive]="true"
                 [nzParagraph]="{ rows: 2 }"></nz-skeleton>
  </div>
  <ng-container *ngIf="messages">
    <div *ngFor="let message of messages; trackBy: trackMessages; let i = index"
         class="message-wrapper {{ message.type }}-message"
         [@fadeInUp]>
      <!-- Visible message content -->
      <ng-container>
        <div #messageContentWrapper
             [id]="message.id || message._id || message.name || i"
             class="message-container container">
          <div class="avatar-message-wrapper {{ message.type }}-message-wrapper">
            <div class="avatar-message-body-wrapper">
              <div class="avatar">
                <ng-container *ngIf="message.senderId !== aiSenderId && message.displayAvatar">
                  <rappider-avatar [text]="receiverAvatar?.text"
                                   [icon]="receiverAvatar?.icon"
                                   [shape]="receiverAvatar?.shape"
                                   [colorSettings]="receiverAvatar?.colorSettings"
                                   [imageUrl]="receiverAvatar?.imageUrl">
                  </rappider-avatar>
                </ng-container>
                <ng-container *ngIf="message.senderId === aiSenderId && message.displayAvatar">
                  <rappider-avatar [text]="senderAvatar?.text"
                                   [icon]="senderAvatar?.icon"
                                   [shape]="senderAvatar?.shape"
                                   [colorSettings]="senderAvatar?.colorSettings"
                                   [imageUrl]="senderAvatar?.imageUrl">
                  </rappider-avatar>
                </ng-container>
              </div>
              <div
                   class="message-body-wrapper {{message.senderId === aiSenderId ? 'ai' : 'user'}}-message-body-wrapper">
                <div *ngIf="message?.type !== MessageType.Planning"
                     class="message {{message.senderId === aiSenderId ? 'ai' : 'user'}}-message">
                  <div class="card {{message.senderId === aiSenderId ? 'ai' : 'user'}}-card">
                    <div class="card-body">
                      <!-- Message header with collapse button -->
                      <div *ngIf="message.senderId === aiSenderId" class="message-header">
                        <div class="message-text-container">
                          <!-- ERROR MESSAGE ALERT -->
                          <rappider-alert *ngIf="isErrorMessage(message)"
                                          [type]="AlertTypes.Error"
                                          [title]="{
                                            content: 'Error',
                                            type: HeadingType.H4
                                          }"
                                          [description]="{
                                            text: isString(message.message) ? message.message : (message?.data?.answer ?? message?.data?.message ?? message?.data?.answerAsMarkdown ?? message?.data?.content ?? message?.content)
                                          }"
                                          [showIcon]="true"
                                          [closeable]="false"
                                          [colorSettings]="{
                                            backgroundColor: 'var(--danger-background-color, #fff2f0)'
                                          }"
                                          [borderSettings]="{
                                            border: '1px solid var(--danger-color)',
                                            borderRadius: 'var(--border-radius-2x)'
                                          }">
                          </rappider-alert>

                          <rappider-markdown-viewer *ngIf="!isErrorMessage(message)"
                                                    [markdownText]="isString(message.message) ?  message.message : (message?.data?.answer ?? message?.data?.message ?? message?.data?.answerAsMarkdown  ?? message?.data?.content ?? message?.content)"
                                                    [typeInRealTime]="message.senderId === aiSenderId && !message.animated && i === messages.length - 1 && message.createdDate && isRecentMessage(message.createdDate)"
                                                    (realtimeTypingCompleted)="onRealtimeTypingCompleted(message)"
                                                    (typingInProgress)="onRealtimeTypingInProgress($event)"
                                                    [typingSpeed]="1"></rappider-markdown-viewer>
                            <div *ngIf="message?.data?.additionalMessages?.length > 0 && message?.data?.additionalMessages?.[0]?.sourceChunks?.length > 0"
                                  class="additional-messages-visibility-button">
                              <rappider-button [text]="isAdditionalMessagesCollapseVisible ? 'Hide Sources' : 'Show Sources'"
                                               [icon]="{name: isAdditionalMessagesCollapseVisible ? 'fa-regular fa-caret-large-down' : 'fa-regular fa-caret-large-right'}"
                                               [borderSettings]="isAdditionalMessagesCollapseVisible ? {borderBottom: '0px var(--secondary-border-color)',borderRadius: '0.5rem 0.5rem 0 0', borderStyle:'solid'} : {borderBottom: '1px var(--secondary-border-color)', borderRadius: '0.5rem', borderStyle:'solid'}"
                                               [shadowSettings]="isAdditionalMessagesCollapseVisible ? {boxShadow:'none'} : {boxShadow:'0 2px 0 rgba(0,0,0,.015)'}"
                                               (click)="onAdditionalMessageVisibilityChange()"></rappider-button>
                            </div>
                            <div *ngIf="isAdditionalMessagesCollapseVisible && message?.data?.additionalMessages?.length > 0" class="button-dropdown-wrapper">
                              <section class="additional-messages-section-wrapper">
                              <ng-container *ngIf="isAdditionalMessagesCollapseVisible">
                                <div *ngFor="let additionalMessage of message?.data?.additionalMessages">
                                  <section>
                                    <div class="additional-message-result">
                                      <rappider-heading [content]="additionalMessage?.result"
                                                        [type]="'h2'"
                                                        [typography]="{fontWeight:'normal',fontSize:'var(--subtext-font-size)'}"></rappider-heading>
                                    </div>
                                    <div *ngFor="let additionalSource of additionalMessage?.sourceChunks">
                                      <div class="additional-source">
                                        <rappider-input-label [title]="additionalSource.source"
                                                              [typography]="{fontSize:'var(--subtext-font-size)'}"
                                                              [icon]="{ name: 'fa-regular fa-link' }"></rappider-input-label>
                                                              &nbsp;
                                        <rappider-paragraph *ngIf="additionalSource.pageNumber"
                                                            [content]="'('"
                                                            [typography]="{fontSize:'var(--subtext-font-size)'}"></rappider-paragraph>
                                        <rappider-icon *ngIf="additionalSource.pageNumber"
                                                       [name]="'fa-regular fa-page'"
                                                       [size]="'var(--subtext-font-size)'"></rappider-icon>
                                        <rappider-input-label *ngIf="additionalSource.pageNumber"
                                                              [title]="'page' + ' ' + additionalSource.pageNumber + ')'"
                                                              [typography]="{fontSize:'var(--subtext-font-size)'}"></rappider-input-label>
                                      </div>
                                    </div>
                                  </section>
                                </div>
                              </ng-container>
                            </section>
                          </div>
                        </div>
                         <!-- expand collapse buttons - only show if there's response data and it's not empty -->
                         <div *ngIf="message.responseData && !message.isEmptyResponse" class="message-body-buttons">
                           <button nz-button
                                   nz-tooltip="Expand/Collapse the supplementary message panels"
                                   [nzSize]="'small'"
                                   [nzType]="'text'"
                                   class="collapse-button"
                                   (click)="toggleMessageDetailsCollapse()">
                             <i class="fa-regular fa-angles-up"
                                [@rotateIcon]="messageDetailsCollapsed ? 'down' : 'up'"></i>
                           </button>
                         </div>
                      </div>

                      <!-- User message text (no collapse button) -->
                      <div *ngIf="message.senderId !== aiSenderId" class="message-text-container">
                        <!-- User message with files -->
                        <div *ngIf="message.attachedFiles && message.attachedFiles.length > 0" class="user-message-files">
                          <!-- All files displayed as images -->
                          <div class="attached-files-horizontal">
                            <div *ngFor="let file of getDisplayFiles(message.attachedFiles); let i = index"
                                 class="attached-file-item"
                                 [class.has-more]="i === 5 && message.attachedFiles.length > 6">
                              <div class="file-image-container">
                                <img *ngIf="isImageFile(file)"
                                     [src]="getFilePreviewUrl(file)"
                                     [alt]="file.name"
                                     class="file-image">
                                <div *ngIf="!isImageFile(file)"
                                     class="file-icon-placeholder">
                                  <i [class]="getFileIcon(file.name)"></i>
                                </div>
                                <div class="file-name-overlay">
                                  <span class="file-name-text" [title]="file.name">{{ getShortFileName(file.name) }}</span>
                                </div>
                                <div *ngIf="i === 4 && message.attachedFiles.length > 5"
                                     class="more-files-overlay"
                                     [title]="getHiddenFileNamesTooltip(message.attachedFiles)">
                                  <span class="more-count">+{{ message.attachedFiles.length - 5 }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <rappider-markdown-viewer [markdownText]="isString(message.message) ?  message.message : (message?.data?.answer ?? message?.data?.message ?? message?.data?.answerAsMarkdown  ?? message?.data?.content ?? message?.content)"
                                                  [typeInRealTime]="message.senderId === aiSenderId && !message.animated && i === messages.length - 1 && message.createdDate && isRecentMessage(message.createdDate)"
                                                  (realtimeTypingCompleted)="onRealtimeTypingCompleted(message)"
                                                  (typingInProgress)="onRealtimeTypingInProgress($event)"
                                                  [typingSpeed]="1"></rappider-markdown-viewer>
                      </div>

                       <!-- AI RESPONSE RENDERER -->
                       <div *ngIf="message.senderId === aiSenderId && message.responseData && !message.isEmptyResponse"
                            [@slideInOut]="messageDetailsCollapsed ? 'out' : 'in'">
                         <rappider-ai-response-renderer
                           [message]="message"
                           [responseType]="message.responseType"
                           [allMessages]="messages"
                           (responseAction)="onResponseAction($event)"
                           (splitterToggleRequested)="onSplitterToggleRequested($event)"
                           (revertRequested)="onRevertRequested($event)">
                         </rappider-ai-response-renderer>
                       </div>

                      <!-- SHOW WITH COMPONENT -->
                      <ng-container *ngIf="
                        message?.data &&
                        message?.displayWithComponent &&
                        message?.displayWithComponent?.componentDefinition
                      ">
                        <ng-container *ngIf="
                          message?.displayWithComponent?.componentDefinition
                            ?.packageName === '@rapider/project-components'
                        ">
                          <rappider-compiled-component-renderer [componentDefinition]="
                            message?.displayWithComponent?.componentDefinition
                          "
                                                                [componentInputs]="message?.data"></rappider-compiled-component-renderer>
                        </ng-container>
                      </ng-container>
                      <!-- END OF SHOW WITH COMPONENT -->

                      <!-- TEST FOR FLUTTER COMPONENT-->
                      <!-- <rappider-compiled-component-renderer [componentType]="'flutter'"
                                                            [componentDefinition]="{
                                                            bundleUrl: 'https://dev.api.rappider.com/source-code/component-definition-file-content?filePath=a3c4ddd0-f9e4-482e-8504-37fd4efd61ff/dist/flutter_test.js',
                                                            id: 'component_definition_id_mock'
                                                            }"
                                                            [component]="{
                                                            id: 'component_id_mock'
                                                            }">
                      </rappider-compiled-component-renderer> -->
                      <!-- END OF TEST -->

                      <!-- CHART -->
                      <div *ngIf="message?.data?.chart && message?.data?.chart.config && message?.data?.chart.data && message.senderId === aiSenderId"
                           class="mt-4"
                           [@slideInOut]="messageDetailsCollapsed ? 'out' : 'in'">
                        <rappider-g2-candlestick-chart [chartTitle]="'Daily Temperature Fluctuation'"
                                                       [xAxisTitle]="'Date'"
                                                       [yAxisTitle]="'Temperature (°C)'"
                                                       [data]="message?.data?.chart.data"></rappider-g2-candlestick-chart>
                      </div>
                      <!-- END CHART -->

                      <!-- MESSAGE DATA -->
                      <div *ngIf="message?.data?.entityData?.length && message.senderId === aiSenderId"
                           [@slideInOut]="messageDetailsCollapsed ? 'out' : 'in'">
                        <section class="message-section-container entity-data-container mt-4">
                          <nz-collapse nzGhost
                                       class="entity-data-container-collapse">
                            <nz-collapse-panel class="entity-data-container-collapse-panel"
                                               [nzActive]="!messageDetailsCollapsed"
                                               [nzHeader]="dataPanelHeader">
                            <section *ngFor="let entityData of message?.data?.entityData">



                              <!-- COLLAPSE BUTTONS -->
                              <div class="entity-list-header">
                              </div>
                              <!-- END BUTTONS -->

                              <nz-collapse-panel nzActive="true"
                                                 class="entity-data-collapse-container"
                                                 [nzHeader]="entityData?.entityName">
                                <ng-container *ngIf="entityData?.data?.length">
                                  <rappider-list-grid *ngIf="entityData?.displayMode === 'grid' && entityData?.data?.length"
                                                      [config]="entityConfigs?.[entityData?.entityName]?.config?.listGridConfig"
                                                      [data]="entityData?.data ?? []"></rappider-list-grid>

                                  <rappider-json-viewer *ngIf="!entityData?.displayMode && entityData?.data?.length"
                                                        [data]="entityData?.data"></rappider-json-viewer>

                                </ng-container>
                              </nz-collapse-panel>

                            </section>

                            </nz-collapse-panel>
                          </nz-collapse>
                          <ng-template #dataPanelHeader>
                            <i class='fa-regular fa-database'></i> &nbsp; Underlying Data
                          </ng-template>
                        </section>
                      </div>
                      <!-- END OF MESSAGE DATA -->

                      <!-- PAGE VIEWER Collapse -->
                      <section class="ui-page-content message-section-container"
                               *ngIf="false && message.senderId === aiSenderId">
                        <nz-collapse nzGhost
                                     class="entity-data-container-collapse">
                          <nz-collapse-panel class="entity-data-container-collapse-panel"
                                             [nzActive]="!messageDetailsCollapsed"
                                             [nzHeader]="uiPagePanelHeader">

                            <ng-template #uiPagePanelHeader>
                              <div class="ui-page-content-header">

                                <div class="d-flex align-items-baseline">
                                  <i class='fa-regular fa-browser'></i> &nbsp; Dashboard
                                </div>
                                <div *ngIf="!messageDetailsCollapsed"
                                     class="d-flex align-items-baseline">
                                  <button nz-button
                                          [routerLink]="['//content-editor/:pageId']">
                                    <i class='fa-regular fa-sparkles'></i> &nbsp; Edit This UI on Editor using AI
                                  </button>
                                </div>
                              </div>
                            </ng-template>

                            <!-- PAGE VIEWER -->

                            <!-- <rappider-ui-page-renderer
                                                       [pageId]="'pageId'"></rappider-ui-page-renderer> -->

                            <!-- END OF PAGE VIEWER -->
                          </nz-collapse-panel>
                        </nz-collapse>
                      </section>
                      <!-- END OF PAGE VIEWER Collapse -->


                      <!-- AI ACTION BUTTONS -->
                      <div *ngIf="message?.data?.entityData?.length && message.senderId === aiSenderId"
                           class="ai-entity-action-buttons-container"
                           [@slideInOut]="messageDetailsCollapsed ? 'out' : 'in'">
                        <hr class="ai-entity-action-buttons-divider">
                        <ng-container *ngFor="let entityData of message?.data?.entityData">
                          <rappider-button *ngIf="entityData?.entityName === 'Patients'"
                                           (confirm)="onRecommendAppointmentButtonClicked(message)"
                                           class="ai-entity-action-button"
                                           [text]="'Recommend Appointment'"
                                           [type]="'default'"
                                           [icon]="{name: 'fa fa-sparkles'}"
                                           [tooltipText]="'Recommend an appointment for the patient based on the data'"></rappider-button>
                        </ng-container>

                      </div>

                      <!-- END AI ACTION BUTTONS -->


                    </div>
                  </div>
                </div>
                <div *ngIf="message?.type === MessageType.Planning &&  message?.data?.operations?.length"
                     class="message">
                  <nz-timeline>
                    <ng-container *ngFor="let operation of message?.data?.operations">
                      <ng-container *ngIf="operation?.operation">
                        <ng-container *ngIf="operation?.operation === 'get'">
                          <nz-timeline-item [nzDot]="getOperationIconTemplate">
                            <nz-tag *ngIf="operation?.entity">{{operation?.entity}}</nz-tag><br />
                            {{operation?.description}}
                          </nz-timeline-item>
                        </ng-container>

                        <ng-container *ngIf="operation?.operation === 'create'">
                          <nz-timeline-item [nzDot]="createOperationIconTemplate">
                            <nz-tag *ngIf="operation?.entity">{{operation?.entity}}</nz-tag><br />
                            {{operation?.description}}</nz-timeline-item>
                        </ng-container>

                        <ng-container *ngIf="operation?.operation === 'update'">
                          <nz-timeline-item [nzDot]="updateOperationIconTemplate">
                            <nz-tag *ngIf="operation?.entity">{{operation?.entity}}</nz-tag><br />
                            {{operation?.description}}</nz-timeline-item>
                        </ng-container>

                        <ng-container *ngIf="operation?.operation === 'delete'">
                          <nz-timeline-item [nzDot]="deleteOperationIconTemplate">
                            <nz-tag *ngIf="operation?.entity">{{operation?.entity}}</nz-tag><br />
                            {{operation?.description}}</nz-timeline-item>
                        </ng-container>
                      </ng-container>

                      <ng-container *ngIf="!operation?.operation">
                        <nz-timeline-item>
                          <nz-tag *ngIf="operation?.entity">{{operation?.entity}}</nz-tag>&nbsp;
                          {{operation?.description}}</nz-timeline-item>
                      </ng-container>
                    </ng-container>
                  </nz-timeline>

                  <ng-template #createOperationIconTemplate>
                    <i class="fa-regular fa-circle-plus"></i>
                  </ng-template>

                  <ng-template #updateOperationIconTemplate>
                    <i class="fa-regular fa-circle-check"></i>
                  </ng-template>

                  <ng-template #deleteOperationIconTemplate>
                    <i class="fa-regular fa-circle-xmark"></i>
                  </ng-template>

                  <ng-template #getOperationIconTemplate>
                    <i class="fa-regular fa-circle-info"></i>
                  </ng-template>
                </div>
                <div *ngIf="message.additionalButton"
                     class="additional-button">
                  <rappider-button [text]="message.additionalButton.text"
                                   [type]="message.additionalButton.type || 'default'"
                                   [icon]="message.additionalButton.icon"
                                   [tooltipText]="message.additionalButton.tooltipText"
                                   [disabled]="message.additionalButton.disabled"
                                   (confirm)="onMessageButtonClick(message)"></rappider-button>
                </div>
                <div *ngIf="message?.conversationButtons?.length"
                     class="additional-button">
                  <rappider-button *ngFor="let button of message?.conversationButtons"
                                   [text]="button?.text"
                                   [type]="button?.type || 'default'"
                                   [icon]="button?.icon"
                                   [tooltipText]="button?.tooltipText"
                                   [disabled]="button?.disabled"
                                   (confirm)="onMessageButtonClick(message)"></rappider-button>
                </div>
              </div>
            </div>
            <div *ngIf="message.date ?? message.createdDate"
                 class="message-time {{message.senderId === aiSenderId ? 'ai' : 'user'}}-message-time">
              {{message.date ?? message.createdDate | fromNow}}
            </div>
          </div>
        </div>
        <!-- End of message-container -->
      </ng-container>


      <!-- End of Placeholder for message content -->
    </div>
  </ng-container>

  <!-- AI Typing Indicator -->
  <div *ngIf="isTyping" class="message-wrapper ai-message" [@fadeInUp]>
    <div class="message-container container">
      <div class="avatar-message-wrapper ai-message-wrapper">
        <div class="avatar-message-body-wrapper">
          <div class="message-body-wrapper ai-message-body-wrapper">
            <div class="ai-typing-indicator">
              <div class="typing-dots">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
              </div>
              <span class="typing-text">AI is thinking...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Scroll into end anchor -->
  <div id="bottom-anchor"></div>
</div>
